var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoomLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1406.9pt",
    height: "507.7pt",
    viewBox: "0 0 1406.9 507.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1141 158 L 1406.898438 158 L 1406.898438 349 L 1141 349 Z M 1141 158 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 11 11 L 496 11 L 496 496 L 11 496 Z M 11 11 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 11.898438 253.898438 C 11.898438 387.554688 120.246094 495.898438 253.898438 495.898438 C 387.554688 495.898438 495.898438 387.554688 495.898438 253.898438 C 495.898438 120.246094 387.554688 11.898438 253.898438 11.898438 C 120.246094 11.898438 11.898438 120.246094 11.898438 253.898438 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 16 16 L 492 16 L 492 492 L 16 492 Z M 16 16 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 16.703125 253.898438 C 16.703125 384.902344 122.898438 491.101563 253.898438 491.101563 C 384.902344 491.101563 491.101563 384.902344 491.101563 253.898438 C 491.101563 122.898438 384.902344 16.699219 253.898438 16.699219 C 122.898438 16.699219 16.703125 122.898438 16.703125 253.898438 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 35 35 L 473 35 L 473 473 L 35 473 Z M 35 35 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 35.703125 253.898438 C 35.703125 374.40625 133.390625 472.101563 253.898438 472.101563 C 374.410156 472.101563 472.101563 374.40625 472.101563 253.898438 C 472.101563 133.390625 374.410156 35.699219 253.898438 35.699219 C 133.390625 35.699219 35.703125 133.390625 35.703125 253.898438 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 111 177 L 392 177 L 392 330 L 111 330 Z M 111 177 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 268.699219 177.898438 L 119.199219 177.898438 C 115 178 111.601563 181.300781 111.5 185.601563 L 111.5 288 C 111.601563 311.199219 130.5 329.898438 153.699219 329.800781 L 303.199219 329.800781 C 307.402344 329.800781 310.800781 326.398438 310.902344 322.199219 L 310.902344 219.699219 C 310.800781 196.5625 292.003906 177.898438 268.886719 177.898438 C 268.824219 177.898438 268.761719 177.898438 268.699219 177.898438 M 382 180.5 L 320.300781 225.601563 L 320.300781 282.300781 L 382 327.398438 C 386.402344 330.800781 391.5 331.800781 391.5 322.699219 L 391.5 185.199219 C 391.5 180.210938 389.945313 177.914063 387.488281 177.914063 C 385.957031 177.914063 384.074219 178.808594 382 180.5 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(29.026794%,54.881287%,100%)",
      fillOpacity: 1
    },
    d: "M 877.601563 294.101563 C 855.300781 316.300781 819.300781 316.199219 797.101563 294 C 775 271.800781 775 235.800781 797.101563 213.601563 C 819.300781 191.300781 855.300781 191.300781 877.601563 213.5 L 877.699219 213.601563 C 900 235.800781 899.898438 271.898438 877.601563 294.101563 M 837.5 159 L 837.398438 159 C 785 159 742.601563 201.5 742.601563 253.800781 C 742.601563 306.199219 785 348.699219 837.398438 348.699219 C 889.800781 348.699219 932.300781 306.300781 932.300781 253.898438 C 932.300781 201.5 889.898438 159 837.5 159 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(29.026794%,54.881287%,100%)",
      fillOpacity: 1
    },
    d: "M 723.601563 311.300781 L 714.101563 310.800781 L 628.699219 310.800781 L 742.601563 196.898438 L 742.101563 187.398438 C 741.699219 172.101563 729.398438 159.800781 714.101563 159.398438 L 704.601563 158.898438 L 562.300781 158.898438 L 562.800781 168.398438 C 563.5 183.5 575.601563 195.699219 590.800781 196.398438 L 600.300781 196.898438 L 685.699219 196.898438 L 571.800781 310.800781 L 572.300781 320.300781 C 572.800781 335.5 585.101563 347.800781 600.300781 348.300781 L 609.800781 348.800781 L 752.101563 348.800781 L 751.601563 339.300781 C 750.300781 323.601563 739.199219 312.199219 723.601563 311.300781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 877.601563 213.398438 C 855.300781 191.199219 819.300781 191.300781 797.101563 213.5 C 775 235.699219 775 271.699219 797.101563 293.898438 C 819.300781 316.199219 855.300781 316.199219 877.601563 294 C 899.898438 271.800781 899.898438 235.800781 877.699219 213.5 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(29.026794%,54.881287%,100%)",
      fillOpacity: 1
    },
    d: "M 1330.898438 159 C 1309.101563 159 1288.398438 168.398438 1274 184.699219 C 1248.800781 156.101563 1206.199219 150.601563 1174.601563 172 C 1167.300781 163.699219 1150.699219 159 1141.199219 159 L 1141.199219 348.800781 L 1150.699219 348.300781 C 1166.5 347.300781 1178.101563 336.101563 1178.699219 320.300781 L 1179.199219 310.800781 L 1179.199219 244.398438 L 1179.699219 234.898438 C 1179.699219 228.300781 1181.398438 221.800781 1184.398438 215.898438 C 1194.800781 197.800781 1218 191.601563 1236.199219 202.101563 C 1241.898438 205.398438 1246.699219 210.199219 1250 215.898438 L 1249.898438 215.898438 C 1253 221.800781 1254.601563 228.300781 1254.601563 234.898438 L 1255.101563 244.398438 L 1255.101563 310.800781 L 1255.601563 320.300781 C 1256.199219 335.5 1268.300781 347.699219 1283.5 348.300781 L 1293 348.800781 L 1293 244.398438 L 1293.5 234.898438 C 1293.5 228.199219 1295.101563 221.699219 1298.199219 215.800781 C 1308.699219 197.699219 1332 191.5 1350.101563 202.101563 C 1355.800781 205.398438 1360.601563 210.199219 1363.898438 215.898438 C 1366.898438 221.800781 1368.5 228.300781 1368.5 234.898438 L 1369 244.398438 L 1369 310.800781 L 1369.5 320.300781 C 1370 335.5 1382.199219 347.699219 1397.398438 348.300781 L 1406.898438 348.800781 L 1406.898438 234.898438 C 1406.800781 193 1372.800781 159 1330.898438 159 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(29.026794%,54.881287%,100%)",
      fillOpacity: 1
    },
    d: "M 1076.898438 294.101563 C 1054.601563 316.300781 1018.601563 316.199219 996.398438 294 C 974.300781 271.800781 974.300781 235.800781 996.398438 213.601563 C 1018.601563 191.300781 1054.601563 191.300781 1076.898438 213.5 L 1077 213.601563 C 1099.300781 235.800781 1099.199219 271.898438 1076.898438 294.101563 M 1103.800781 186.800781 C 1086 169 1061.898438 159 1036.699219 159 C 1011.5 159 987.398438 169 969.601563 186.800781 C 932.601563 223.898438 932.601563 284 969.699219 321 C 1006.800781 358 1066.898438 358 1103.898438 320.898438 C 1141 283.898438 1140.898438 223.800781 1103.800781 186.800781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 1076.898438 213.398438 C 1054.601563 191.199219 1018.601563 191.300781 996.398438 213.5 C 974.300781 235.699219 974.300781 271.699219 996.398438 293.898438 C 1018.601563 316.199219 1054.601563 316.199219 1076.898438 294 C 1099.199219 271.800781 1099.199219 235.800781 1077 213.5 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(89.84375%,89.84375%,89.451599%)",
      fillOpacity: 1
    },
    d: "M 0 507.699219 L 507.703125 507.699219 L 507.703125 0 L 0 0 Z M 0 507.699219 "
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 4.800781 503 L 503 503 L 503 4.800781 L 4.800781 4.800781 Z M 4.800781 503 "
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(29.026794%,54.881287%,100%)",
      fillOpacity: 1
    },
    d: "M 23.800781 484 L 484 484 L 484 23.800781 L 23.800781 23.800781 Z M 23.800781 484 "
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 99.699219 341.601563 L 403.398438 341.601563 L 403.398438 166.101563 L 99.699219 166.101563 Z M 99.699219 341.601563 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomLogo);
export default __webpack_public_path__ + "static/media/ZoomLogo.dd99654db342e5009a44af11417a539f.svg";
export { ForwardRef as ReactComponent };